module.exports = __webpack_public_path__ + "img/hori2.ad67ac2c.png";